import { css } from '@emotion/react';
import React, { useContext, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { getSelectedCourse } from 'redux/selectors/analytics';

import Icon from 'cohort_management/components/icon';
import ClickableContainer from 'components/clickable-container';
import { Course } from 'redux/schemas/models/course';
import NvIcon from 'shared/components/nv-icon';
import useClickOutside from 'shared/hooks/use-click-outside';
import CourseSearchDropdown from './course-search-dropdown';
import { AnalyticsContext } from '../analytics-dashboard';

type SelectCourseProps = {
  title: string;
  canEditCourse: boolean;
  preCatalogId?: string;
};

const styles = css`
  &.course-search {
    width: fit-content;
    .bs4-dropdown .title {
      width: 400px;
    }
  }
  .bs4-dropdown-menu {
    max-height: 480px;
    overflow-y: auto;
  }
  .ellipsis {
    white-space: nowrap;
  }
`;
const SelectCourse: React.FC<SelectCourseProps> = ({
  title,
  canEditCourse,
  preCatalogId,
}) => {
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const courseSearchRef = useRef<HTMLDivElement>(null);

  const { watch } = useFormContext();
  const { analyticsPageType } = useContext(AnalyticsContext);
  const selectedCourseCatalogid = preCatalogId ?? watch('postCourseCatalogId');

  const selectedCourse = useSelector(state => getSelectedCourse(state, analyticsPageType, selectedCourseCatalogid));

  useClickOutside(courseSearchRef, () => {
    setShowSearchDropdown(false);
  });

  return (
    <div
      className='d-flex mb-1 align-items-center course-search'
      css={styles}
      ref={courseSearchRef}
    >
      <span className='mr-1'>{title}</span>
      {selectedCourse && !showSearchDropdown && (
        <ClickableContainer
          onClick={() => setShowSearchDropdown(true)}
          className={`d-flex align-items-center ${canEditCourse ? 'cursor-pointer text-primary' : 'pointer-events-none'}`}
          disabled={!canEditCourse}
        >
          <Icon course={selectedCourse as Course} className='cohort-management-icon' />
          <span className={`ml-1 ${!canEditCourse ? 'font-weight-bolder' : ''}`}>
            {selectedCourse?.name}
          </span>
          {canEditCourse && (
            <NvIcon
              icon='dropdown-arrow'
              size='xss-smallest'
              className='ml-1'
            />
          )}
        </ClickableContainer>
      )}
      {(showSearchDropdown || !selectedCourse) && canEditCourse && (
        <CourseSearchDropdown
          onSelect={() => setShowSearchDropdown(false)}
        />
      )}
    </div>
  );
};

export default SelectCourse;
